(function() {
	/**
	 * Renders news list page: [News Item]
	 * @param {Object} props - The Routing and page context and properties
	 * @returns {object} 	Promise with data (nav for menu, etc.)
	 */
	WebBaseAprovLV.renderArticlesPage = function(props) {
		var params = {
			page: props.context.params.page || '',
			detail: props.context.params.detail || ''
		};
		var model = {
			element: null,
			template: 'templates/articles.ejs.html?v=' + WebBaseAprovLV.version.template,
			data: {
				main: (props.context.Model || {}).Main || {}, /* Comes from renderMainContent() */
				pageRaw: null,
				navRaw: null,
				articlesRaw: null,
				categories: null,
				tags: [
					{
						codename: 'news_article',
						name: 'Tags|Tags'
					}
				],
				articles: null,
				nav: null,
				pageContent: null
			}
		};
		var queryString = WebBaseAprovLV.Utils.parseQuerystring(props.context.querystring);

		return $.when(
			WebBaseAprovLV.Utils.getKKData('?system.type=page&elements.url[in]=' + params.page),
			(function() {
				var cache = WebBaseAprovLV.Cache.get('taxonomies.news_categories').value;
				if (cache) {
					return $.Deferred().resolve(cache).promise();
				}
				return WebBaseAprovLV.Utils.getTaxonomies({groupname: 'news_categories'}, (props.customShowAllNewsCategories ? (props.customNewsProjectID || null) : ''));
			})(),
			(function() {
				var cache = WebBaseAprovLV.Cache.get('taxonomies.news_tag').value;
				if (cache) {
					return $.Deferred().resolve(cache).promise();
				}
				return WebBaseAprovLV.Utils.getTaxonomies({groupname: 'news_tag'}, (props.customShowAllNewsTags ? (props.customNewsProjectID || null) : ''));
			})()
		)
		.then(function(pageXhr, taxonomiesCategoriesXhr, taxonomiesTagsXhr) {
			var pageRaw = Array.isArray(pageXhr) && pageXhr.length ? pageXhr[0] : (pageXhr || {});
			var taxonomyCategories = Array.isArray(taxonomiesCategoriesXhr) ? taxonomiesCategoriesXhr[0] : taxonomiesCategoriesXhr;
			var taxonomyTags = Array.isArray(taxonomiesTagsXhr) ? taxonomiesTagsXhr[0] : (taxonomiesTagsXhr || {});
			var limit = WebBaseAprovLV.pagingWindow || 10;
			var filters = {
				categories: (queryString.categories || '').toLowerCase(),
				tags: (queryString.tags || '').toLowerCase(),
			};
			var categoryQueries = [];
			var tagsQueries = [];	
			var categoryQueryString = (props.customCategoryValue && props.customCategoryValue.length > 0) ? '&elements.news_categories[any]=' +  props.customCategoryValue : '';
			var tagQueryString = (props.customTagValue && props.customTagValue.length > 0) ? '&elements.news_tag[any]=' +  props.customTagValue : '';
			var categories = model.data.categories = taxonomyCategories.terms || [
				{
					codename: 'news_news',
					name: 'News|News'
				}
			];
			var orderParams = [{
				field: (queryString.order || '').toLowerCase(),
				dir: (queryString.dir || '').toLowerCase(),
				value: ''
			}];
			var orderQueries = [];
			var orderQueryString = '';
			var modularContentNews;
			taxonomyTags.terms && (model.data.tags = taxonomyTags.terms);			
			WebBaseAprovLV.Cache.set('taxonomies.news_categories', taxonomyCategories);
			if (pageRaw.items && Array.isArray(pageRaw.items) && pageRaw.items.length) {
				model.data.pageRaw = pageRaw;
				// Category filter:
				modularContentNews = Object.values(pageRaw.modular_content || {}).filter(function(item) {
					return /news_container/i.test((item.system || {}).type || '');
				});
				if (modularContentNews.length > 0 && (((modularContentNews[0].elements || {}).news_categories || {}).value || []).length) {
					// there are some selected categories in the news_container, so that only these categories
					// should be displayed in the category list of the page and the news should only be filtered
					// by these categories instead of all taxonomies (fetched earlier).
					// if the categories are filtered using one or more querystrings, the category-filter
					// instantiated right here (categoryQueryString) will be overwritten by the
					// querystring-filter later on.
					categories = model.data.categories = modularContentNews[0].elements.news_categories.value;
					categoryQueryString = '&elements.news_categories';
					categoryQueries = modularContentNews[0].elements.news_categories.value.map(function(item) {
						return item.codename || '';
					});
					if (categoryQueries.length === 1) {
						categoryQueryString += '[contains]=' + encodeURIComponent(categoryQueries[0]);
					} else if (categoryQueries.length > 1) {
						categoryQueryString += '[any]=' + encodeURIComponent(categoryQueries.join(','));
					}
				}
				if (filters.categories.length) {
					categoryQueries = categories.filter(function(item) {
						return (new RegExp('(^|,)' + item.codename + '(,|$)', 'i')).test(filters.categories);
					}).map(function(item) {
						return item.codename;
					});
					if (categoryQueries.length) {
						categoryQueryString = '&elements.news_categories';
						if (categoryQueries.length === 1) {
							categoryQueryString += '[contains]=' + encodeURIComponent(categoryQueries[0]);
						} else if (categoryQueries.length > 1) {
							categoryQueryString += '[any]=' + encodeURIComponent(categoryQueries.join(','));
						}
					}
				}
				// Tags filter:
				if (filters.tags.length) {
					let subTagQueries = [];
					tagsQueries = model.data.tags.filter(function(item) {												
						if(item.hasOwnProperty('terms') && item.terms.length > 0) {
							subTagQueries = item.terms.filter(function(subItem) {	
								return (new RegExp('(^|,)' + subItem.codename + '(,|$)', 'i')).test(filters.tags);
							}).map(function(subItem) {
								return subItem.codename;
							});
						}
						// if filter value is found in subtags
						if (subTagQueries.length > 0 )	 {
							return true;
						} else {
							return (new RegExp('(^|,)' + item.codename + '(,|$)', 'i')).test(filters.tags);
						}
					}).map(function(item) {
						if (subTagQueries.length > 0 )	 {
							return subTagQueries;
						} else {
							return item.codename;
						}						
					});
					if (tagsQueries.length) {
						tagQueryString = '&elements.news_tag';
						if (tagsQueries.length === 1) {
							tagQueryString += '[contains]=' + encodeURIComponent(tagsQueries[0]);
						} else {
							tagQueryString += '[any]=' + encodeURIComponent(tagsQueries.join(','));
						}
					}
				}
				// Order:
				orderQueries = orderParams.map(function(item) {
					item.dir = /^(asc|desc)?$/i.test(item.dir) ? item.dir : '';
					switch (item.field) {
						case 'last_modified':
							item.dir = item.dir.length ? item.dir : 'desc';
							item.value = ['system.last_modified[', item.dir, ']'].join('');
							break;
						case 'title':
							item.dir = item.dir.length ? item.dir : 'asc';
							item.value = ['elements.title[', item.dir, ']'].join('');
							break;
						default:
							item.dir = item.dir.length ? item.dir : 'desc';
							item.value = ['elements.date[', item.dir, ']'].join('');
					}
					return item;
				}).filter(function(item) {
					return item.value.length > 0;
				}).map(function(item) {
					return item.value;
				});
				orderQueryString = orderQueries.length ? '&order=' + orderQueries.join(',') : '';
				return WebBaseAprovLV.Utils.getKKData('?system.type=news&includeTotalCount=true' + categoryQueryString + tagQueryString + orderQueryString + (queryString.skip ? '&skip=' + queryString.skip : '') + '&limit=' + limit, (props.customNewsProjectID || null));
			}
			return $.Deferred().reject(model);
		}).then(function(articlesRaw) {
			var key;
			var params = [];
			var paramsDict = {};
			articlesRaw = articlesRaw || {};
			model.data.articlesRaw = articlesRaw;
			model.data.navRaw = {};
			if (model.data.pageRaw && model.data.articlesRaw) {
				// preserve non paging relevant querystring params
				for (key in queryString) {
					switch (true) {
						case /^(skip|limit)/i.test(key):
							break;
						default:
							params.push([key.toLowerCase(), queryString[key]].join('='));
							paramsDict[key.toLowerCase()] = queryString[key];
							break;
					}
				}
				model.element = $('#content');
				model.data = $.extend(model.data, {
					pageContent: WebBaseAprovLV.Utils.getKKViewModel(model.data.pageRaw)[0] || {},
					nav: WebBaseAprovLV.Utils.getKKViewModel(model.data.navRaw)[0] || {},
					articles: (model.data.articlesRaw.items || []).length ? WebBaseAprovLV.Utils.getKKViewModel(model.data.articlesRaw) || [] : [],
					queryStringCollection: paramsDict,
					queryString: params.join('&')
				});
				return WebBaseAprovLV.Utils.transitionTo(model);
			}
			return $.Deferred().reject(model);
		}).then(function(ejsmodel) {
			ejsmodel.data.UILangSwitch = WebBaseAprovLV.Utils.tuneUILangSwitchers({
				page: {
					segment: (props.segment || {
						'de': 'news',
						'it': 'news',
						'lld': 'news'
					})
				}
			}, $('a.langchange'));
			return ejsmodel;
		}).promise();
	};
})();
